<template>
  <v-layout row justify-center>
    <v-dialog v-model="isOpen" persistent>
      <v-card>
        <v-card-title class="headline">Vos Toevoegen</v-card-title>
                <v-card-text>
                <v-select label="Vos" v-model="fox" :items="['Alpha', 'Bravo', 'Charlie', 'Delta', 'Echo', 'Foxtrot']" required></v-select>
                <v-text-field v-model="position.lat" label="Latitude" required></v-text-field>
                <v-text-field v-model="position.lng" label="Longintude" required></v-text-field>
                <v-checkbox v-model="isHunt" label="Hunt" required></v-checkbox>
                <v-text-field v-model="time" label="Tijd" required>HELLO</v-text-field>
            </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="close">Cancel</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
    name: 'AddFoxModal',
    data () {
        return {
            fox: 'Alpha',
            isHunt: false,
            time: null,
            date: null
        }
    },
    props: ['open', 'position', 'close'],
    methods: {
        save() {
            var t = (new Date(this.time).getTime()) - (7200 * 1000);

            this.$store.dispatch('ADD_FOX_LOCATION', {
                fox: this.fox.toLowerCase(),
                lat: this.position.lat,
                lng: this.position.lng,
                isHunt: this.isHunt,
                time: new Date(t)
            });
            this.close();
        }
    },
    computed: {
        isOpen() {
            return this.open;
        }

    },
    watch: {
        isOpen: {
            handler(n, o) {
                var t = new Date().getTime() + (7200 * 1000);
                this.time = new Date(t).toUTCString();
            }
        }
    }
}


</script>




// WEBPACK FOOTER //
// src/components/AddFoxModal.vue